<form [formGroup]="profileForm" class="article-type-masterdata no-field-space">

  <div class="text-selection">
    <sc-flex [centered]="true">
      {{ project?.name }}
      <ng-container *ngIf="project?.validPeriod?.from">
        {{ 'from' | translate: ['erp.ui.project-masterdata.label.from', translationService.language]}}:
        {{project?.validPeriod?.from | date:'dd.MM.yy'}}
      </ng-container>
      <ng-container *ngIf="project?.validPeriod?.until">
        {{ 'until' | translate: ['erp.ui.project-masterdata.label.until', translationService.language]}}:
        {{project?.validPeriod?.until | date:'dd.MM.yy'}}
      </ng-container>
      <ng-container *ngIf="project?.archived">
        {{ '(archived)' | translate: ['erp.ui.project-masterdata.label.archived', translationService.language]}}
      </ng-container>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-icon-button (click)="changeProjectTitle()" [disabled]="project == null">
        <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button [disabled]="project == null || !downloadEnabled" (click)="exportProject()">
        <mat-icon><sc-icon iconClass="fa-download"></sc-icon></mat-icon>
        {{ 'Project' | translate: ['erp.ui.project-masterdata.action.download', translationService.language]}}
      </button>
    </sc-flex>
  </div>
</form>
